<template>
    <div class="auth-hybrid">
        <div class="form-group">
            <button class="btn btn-google btn-block btn-icon-left btn-shadow text-uppercase" @click="socLogin('google')" :style="isMobile ? 'font-size: .7rem' : ''">
                <svg class="svg-icon svg-icon--light" alt="" viewBox="0 0 19 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <path d="M19,10.233871 C19,15.9395161 15.2272541,20 9.6557377,20 C4.31393443,20 0,15.5322581 0,10 C0,4.46774194 4.31393443,0 9.6557377,0 C12.2565574,0 14.4446721,0.987903226 16.1305328,2.61693548 L13.502459,5.23387097 C10.0645492,1.7983871 3.67151639,4.37903226 3.67151639,10 C3.67151639,13.4879032 6.36188525,16.3145161 9.6557377,16.3145161 C13.4790984,16.3145161 14.9118852,13.4758065 15.1377049,12.0040323 L9.6557377,12.0040323 L9.6557377,8.56451613 L18.8481557,8.56451613 C18.9377049,9.0766129 19,9.56854839 19,10.233871 Z"></path>
                </svg>
                {{ $t(`auth.${type}_whit_google`) }}
            </button>
        </div>
        <div class="form-group">
            <button class="btn btn-facebook btn-block btn-icon-left btn-shadow text-uppercase" @click="socLogin('facebook')" :style="isMobile ? 'font-size: .7rem' : ''">
                <svg class="svg-icon svg-icon--light" viewBox="0 0 11 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <path d="M10.1456599,11.25 L10.7086698,7.63046875 L7.18847224,7.63046875 L7.18847224,5.28164063 C7.18847224,4.29140625 7.68021505,3.32617188 9.25680111,3.32617188 L10.8571429,3.32617188 L10.8571429,0.24453125 C10.8571429,0.24453125 9.40487825,0 8.01635809,0 C5.11737187,0 3.22245955,1.73359375 3.22245955,4.871875 L3.22245955,7.63046875 L1.50990331e-14,7.63046875 L1.50990331e-14,11.25 L3.22245955,11.25 L3.22245955,20 L7.18847224,20 L7.18847224,11.25 L10.1456599,11.25 Z" id="path-1"></path>
                </svg>
                {{ $t(`auth.${type}_whit_facebook`) }}
            </button>
        </div>
        <div class="form-group">
            <button class="btn btn-light btn-block btn-icon-right text-uppercase" :style="isMobile ? 'font-size: .7rem' : ''">
                <span class="mr-auto">{{ $t('other_social_media') }}</span>
                <span class="material-icon icon-keyboard_arrow_down"/>
            </button>
        </div>
    </div>
</template>

<script>
  import hybridAuth from 'src/mixins/hybridAuthComponent';

  export default {
    mixins: [hybridAuth],
    methods: {
      socLogin(provider) {
        this.$auth.authenticate(provider).then((data) => {
          // eslint-disable-next-line no-console
          console.log(data);
        });
      },
    },
  };
</script>